import { useMemo } from 'react';
import { pick, prop } from 'ramda';

import { usePortletConfig } from 'js/components/system/Portlet';

import { useGamesSelector } from '@interlayer/js/app/components/main/Games/store/context';

import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { getCookie } from 'js/utils/cookie.util';

export const useGetFeed = () => {
    const gamesFeedsObject = useAppSelector(prop('gamesFeedsObject'));
    const { isLoggedIn, allPlayerTags: playerTags } = useUserSelector(pick(['isLoggedIn', 'allPlayerTags']));
    const { hub2FeedName } = useGamesSelector();
    const {
        gamesConfiguration: {
            gameFeed = hub2FeedName,
            feedCookie,
            profileFeed: feedsByTag
        } = {}
    } = usePortletConfig();

    return useMemo(() => {
        if (feedsByTag && isLoggedIn) {
            if (!playerTags) {
                return;
            }

            for (let index = 0; index < feedsByTag.length; index++) {
                const feedByTags = feedsByTag[index];
                const tags = feedByTags.tags.split(',');

                const tag = tags.find(item => playerTags[item]);

                if (tag && gamesFeedsObject[feedByTags.feedName]) {
                    return gamesFeedsObject[feedByTags.feedName];
                }
            }
        }

        if (feedCookie) {
            const cookieFeed = gamesFeedsObject[getCookie(`_category_feed_${feedCookie}`)];

            if (cookieFeed) {
                return cookieFeed;
            }
        }

        return gamesFeedsObject[gameFeed];
    }, [feedCookie, feedsByTag, gameFeed, gamesFeedsObject, isLoggedIn, playerTags]);
};
